module.exports = __webpack_public_path__ + "media/images/site_btn-a66be5b685958cbc902ddf2ffb44adbf.gif";